import {Navigate, Route, Routes} from "react-router-dom";
import React from "react";
import {SelectedView} from "../types/types";
import DatasetsView from "./DatasetsView";
import QuestionnairesCounts from "./QuestionnairesCounts";
import {DIAGNOSIS_PATH, FILL_CLIENT_FORM_PATH, PROCEDURES_PATH, QUESTIONNAIRES_PATH} from "../consts/consts";
import ClientForm from "./clientFormComponents/ClientForm";

const AppRoutes = (props: any) => {
    const diagnosisElement = (
        <DatasetsView data={props.fetchedData[SelectedView.Diagnosis]}
                      versions={(props.versions && props.versions[SelectedView.Diagnosis]) || []}
                      selectedVersion={props.selectedVersion} setSelectedVersion={props.setSelectedVersion}
                      view={props.view}/>
    );

    const proceduresElement = (
        <DatasetsView data={props.fetchedData[SelectedView.Procedures]}
                      versions={(props.versions && props.versions[SelectedView.Procedures]) || []}
                      selectedVersion={props.selectedVersion} setSelectedVersion={props.setSelectedVersion}
                      view={props.view}/>
    );

    const questionnairesElement = (
        <QuestionnairesCounts data={props.fetchedData[SelectedView.Questionnaires]}/>
    );

    const fillClientFormElement = (
        <ClientForm data={props.fetchedData}/>
    );


    return (
        <Routes>
            <Route path="/" element={<Navigate to={DIAGNOSIS_PATH} replace/>}/>
            <Route path={DIAGNOSIS_PATH} element={diagnosisElement}/>
            <Route path={PROCEDURES_PATH} element={proceduresElement}/>
            <Route path={QUESTIONNAIRES_PATH} element={questionnairesElement}/>
            <Route path={FILL_CLIENT_FORM_PATH} element={fillClientFormElement}/>
            <Route path="*" element={<Navigate to={DIAGNOSIS_PATH} replace/>}/>
        </Routes>
    );
}


export default AppRoutes;